import React from "react";

const InactivityModal: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">Are you still there?</h2>
      <p>
        It's been a while since your last activity. Please refresh the page
      </p>
      <button
        className="btn-purple mt-6"
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  )
}

export default InactivityModal;